import { render } from "./SampleProject.vue?vue&type=template&id=6467d17c"
import script from "./SampleProject.vue?vue&type=script&lang=js"
export * from "./SampleProject.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__